/**
 * src/routes/prestadorRoutes.js
 * Rotas protegidas do prestador
 */

import { lazy, Suspense } from 'react';
import SecureRoute from '../app/Context/privaterouter';
import LoadingSpinner from '../app/ComponentsLogin/LoadingSpinner';

// HOME
const PrestadorHome = lazy(() => import('../app/AgendexPrestador/pages/Home/p_home'));
const PrestadorCadastrarEmpresa = lazy(() => import('../app/AgendexPrestador/pages/Empresa/p_cadastrarempresa'));

// EMPRESA
const PrestadorDetalheEmpresa = lazy(() => import('../app/AgendexPrestador/pages/Empresa/p_detalheempresa'));
const PrestadorServicos = lazy(() => import('../app/AgendexPrestador/pages/Empresa/Servicos/p_servicos'));
const PrestadorRegras = lazy(() => import('../app/AgendexPrestador/pages/Empresa/Regras/p_regras'));
const PrestadorHorarios = lazy(() => import('../app/AgendexPrestador/pages/Empresa/Regras/Horarios/p_horarios'));
const PrestadorFeriados = lazy(() => import('../app/AgendexPrestador/pages/Empresa/Regras/Feriados/p_feriados'));
const PrestadorColaboradores = lazy(() => import('../app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaboradores'));
const PrestadorColaboradorNovo = lazy(() => import('../app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaborador_novo'));
const PrestadorColaboradorEditar = lazy(() => import('../app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaborador_editar'));
const PrestadorColaboradoresServicos = lazy(() => import('../app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaboradores_servicos'));
const PrestadorColaboradoresHorarios = lazy(() => import('../app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaboradores_horarios'));

// AGENDAMENTOS
const PrestadorAgendamentos = lazy(() => import('../app/AgendexPrestador/pages/Agendamentos/p_abertos'));
const PrestadorAgendamentosConcluidos = lazy(() => import('../app/AgendexPrestador/pages/Agendamentos/p_concluidos'));
const PrestadorAgendamentosExcluidos = lazy(() => import('../app/AgendexPrestador/pages/Agendamentos/p_excluidos'));
const PrestadorAgendamentosPendentes = lazy(() => import('../app/AgendexPrestador/pages/Agendamentos/p_pendentes'));

// PERFIL
const PrestadorPerfil = lazy(() => import('../app/AgendexPrestador/pages/Perfil/p_perfil'));
const PrestadorPerfilValidaEmail = lazy(() => import('../app/AgendexPrestador/pages/Perfil/p_ativarconta'));

// CONFIGURAÇÕES
const PrestadorNotificacoesInternas = lazy(() => import('../app/AgendexPrestador/pages/Configuracoes/p_notificacoesinternas'));

// HELPER
const Protected = (Component) => (
  <SecureRoute>
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  </SecureRoute>
);

export const prestadorRoutes = [
  // HOME
  { path: "/app/prestador/home", element: Protected(PrestadorHome) },
  { path: "/app/prestador/perfil/cadastrarempresa", element: Protected(PrestadorCadastrarEmpresa) },

  // EMPRESA
  { path: "/app/prestador/empresa", element: Protected(PrestadorDetalheEmpresa) },
  { path: "/app/prestador/empresa/servicos", element: Protected(PrestadorServicos) },
  { path: "/app/prestador/empresa/regras", element: Protected(PrestadorRegras) },
  { path: "/app/prestador/empresa/regras/horarios", element: Protected(PrestadorHorarios) },
  { path: "/app/prestador/empresa/regras/feriados", element: Protected(PrestadorFeriados) },
  { path: "/app/prestador/empresa/colaboradores", element: Protected(PrestadorColaboradores) },
  { path: "/app/prestador/empresa/colaboradores/novo", element: Protected(PrestadorColaboradorNovo) },
  { path: "/app/prestador/empresa/colaboradores/:id", element: Protected(PrestadorColaboradorEditar) },
  { path: "/app/prestador/empresa/colaboradores/servicos", element: Protected(PrestadorColaboradoresServicos) },
  { path: "/app/prestador/empresa/colaboradores/horarios", element: Protected(PrestadorColaboradoresHorarios) },

  // AGENDAMENTOS
  { path: "/app/prestador/agendamentos/abertos", element: Protected(PrestadorAgendamentos) },
  { path: "/app/prestador/agendamentos/concluidos", element: Protected(PrestadorAgendamentosConcluidos) },
  { path: "/app/prestador/agendamentos/excluidos", element: Protected(PrestadorAgendamentosExcluidos) },
  { path: "/app/prestador/agendamentos/pendentes", element: Protected(PrestadorAgendamentosPendentes) },

  // PERFIL
  { path: "/app/prestador/perfil", element: Protected(PrestadorPerfil) },
  { path: "/app/prestador/perfil/cv", element: Protected(PrestadorPerfilValidaEmail) },

  // CONFIGURAÇÕES
  { path: "/app/prestador/config/notificacoes", element: Protected(PrestadorNotificacoesInternas) }
];